// Assigning form based on screen size

let form;

// Initial form assignment
getFormReference();

// Window resize event listener
// let resizeTimeout;
// window.addEventListener('resize', (e) => {
// 	clearTimeout(resizeTimeout);
// 	resizeTimeout = setTimeout(() => {
// 		location.reload();
// 	}, 500);
// });

// Get form reference based on screen size
function getFormReference() {
	if (window.innerWidth < 750) {
		form = document.querySelector('#mobile-product-filter-form');
		console.log('form', form);
		document.querySelector('#product-filter-form').remove();
	} else {
		form = document.querySelector('#product-filter-form');
		console.log('form', form);
		document.querySelector('.mobile-filter').remove();
	}
}

// DOM Elements
let productContainer = document.querySelector('#ProductGridContainer');

// Get Collection url
const startUrl = window.location.pathname;
const collectionName = startUrl.split('collections/')[1].split('/')[0];
const collectionUrl = `/collections/${collectionName}`;

// Input field name attibute values
const nameSet = new Set();

// Window loading event listener
window.addEventListener('load', (e) => handleURL(e));

// Form Event Listener
form.addEventListener('change', (e) => handleFormEvent(e));

// WIndow popstate event listener
window.addEventListener('popstate', (e) => handleURL(e));

// Form Event Handler
function handleFormEvent(e) {
	e.preventDefault();

	console.log('e.target', e.target, e.target.checked);

	const formData = new FormData(form);
	let tagFilter = createTagFilter(formData);

	// Create a form value object
	const customFilter = {
		year: undefined,
		make: undefined,
		model: undefined,
		engine: undefined,

		yearResults: [],
		makeResults: [],
		modelResults: [],
		engineResults: [],
	};

	// Set data from form to customFilter object
	setValuesFromForm(customFilter, formData);

	//Set up url with tag value ex) /collections/ford/2000
	let url = `${collectionUrl}/${tagFilter}`;

	// Push url to history
	window.history.pushState(null, null, url);

	const checkboxes = document.querySelectorAll(
		`.facets-wrap input[name="${e.target.name}"]`
	);

	console.log('checkboxes', checkboxes);

	// TEST
	updateFilters(customFilter);

	if (e.target.checked) {
		renderProductGrid(url, '');

		// // Query mobile filter tab
		// if (document.querySelector('#mobile-product-filter-form')) {
		// 	document.querySelector(
		// 		`.mobile-filter-tab .${e.target.name}.tab`
		// 	).style.color = '#fd3746';
		// }

		// Hide other checkboxes
		checkboxes.forEach((otherCheckbox) => {
			if (otherCheckbox !== e.target) {
				otherCheckbox.closest(`.${e.target.name}-checkbox`).style.display =
					'none';
			}
		});

		// Render Filter
		renderProductFilter(customFilter, e.target.name);
	} else {
		checkboxes.forEach((allCheckbox) => {
			allCheckbox.closest(`.${e.target.name}-checkbox`).style.display = 'block';
		});
		// Change url and Fetch Data
		renderProductGrid(url, '');

		// Render Filter
		renderProductFilter(customFilter, e.target.name);

		// // Reset mobile filter tab
		// if (document.querySelector('#mobile-product-filter-form')) {
		// 	document.querySelector(
		// 		`.mobile-filter-tab .${e.target.name}.tab`
		// 	).style.color = 'currentColor';
		// }
	}
}

// Handle url with tag value ex) /collections/ford/2000
function handleURL(e) {
	const tagNameParams = e.target.location.pathname
		.split('collections/')[1]
		.split('/')[1];
	const tagNames = tagNameParams
		? tagNameParams.toLowerCase().split('+')
		: undefined;

	// 1. Get all checkboxes
	const checkboxes = document.querySelectorAll(
		`.facets-wrap input[type="checkbox"]`
	);

	// 2. Reset all checkboxes
	checkboxes.forEach((checkbox) => {
		checkbox.checked = false;
		nameSet.clear();
	});

	// 3. Check checkboxes that are in the url

	console.log('tagNames', tagNames);

	if (tagNames) {
		tagNames.forEach((tagName) => {
			console.log(
				'selector in tagNames',
				`.facets-wrap input[value="${tagName}"]`
			);

			const checkedCheckbox = document.querySelector(
				`.facets-wrap input[value="${tagName}"]`
			);
			checkedCheckbox.checked = true;

			nameSet.add(checkedCheckbox.name);
		});
	}

	console.log('nameSet', nameSet);

	// 4. Hide other checkboxes

	checkboxes.forEach((checkbox) => {
		if (!nameSet.has(checkbox.name)) {
			checkbox.closest(`.${checkbox.name}-checkbox`).style.display = 'block';
		} else {
			if (!checkbox.checked) {
				console.log('checkbox', checkbox);
				checkbox.closest(`.${checkbox.name}-checkbox`).style.display = 'none';
			}
		}
	});

	// 5. Render product grid
	renderProductGrid(window.location.pathname, '');
}

// Create Tag Filter
function createTagFilter(formData) {
	let tagFilter = '';

	for (const [key, value] of formData) {
		tagFilter += value + '+';
	}

	return tagFilter.slice(0, -1);
}

// Render Product Grid
async function renderProductGrid(url, searchParams) {
	const response = await fetch(url + searchParams);
	const responseText = await response.text();
	const html = new DOMParser()
		.parseFromString(responseText, 'text/html')
		.getElementById('ProductGridContainer').innerHTML;
	//console.log('html', html);
	productContainer.innerHTML = html;

	// Set up paginate links
	const paginateLinks = document.querySelectorAll(
		'#ProductGridContainer > div > div.pagination-wrapper > nav > ul > li > a'
	);

	//Test Quick View button [begin]
	const quickViewBtn = document.querySelectorAll('.quick-view-btn-on-product');
	const closeQuickViewBtn = document.querySelectorAll('.modal-close');

	quickViewBtn.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			const modal = document.getElementById(`${e.target.dataset.modal}`);
			const input = modal.querySelector('input');
			const displayMsg = modal.querySelector('.quick-vin-decode-display');

			console.log('modal', modal);
			console.log('input', input);
			console.log('displayMsg', displayMsg);

			modal.showModal();

			input.addEventListener('input', (e) => {
				console.log(e.target.value);
				handleModalInput(modal, input, e.target.value, displayMsg);
			});
		});
	});

	closeQuickViewBtn.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			const modal = btn.closest('dialog');
			console.log('modal', modal);
			modal.close();
		});
	});

	//Test Quick View button [end]

	// Set paginate links to empty string to prevent page reload
	paginateLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			url = link.getAttribute('href');
			link.setAttribute('href', '');
			renderProductGrid(url, '');
			// Scroll to top of the form
			form.scrollIntoView();
		});
	});
}

// setting filter object from a form
function setValuesFromForm(customFilter, formData) {
	for (const [key, value] of formData) {
		if (key === 'engine') {
			customFilter[key] = value.replace('-', '.').toUpperCase();
		} else {
			customFilter[key] = value;
		}
	}
}

// For dynamic filtering
function updateFilters(customFilter) {
	for (let make in carsForFilter) {
		for (let model in carsForFilter[make]) {
			for (let year in carsForFilter[make][model]) {
				for (let engine of carsForFilter[make][model][year]) {
					if (checkValid(make, model, year, engine, customFilter)) {
						if (!customFilter.year || year === customFilter.year) {
							customFilter.yearResults.push(year);
						}
						if (!customFilter.make || make === customFilter.make) {
							customFilter.makeResults.push(make);
						}
						if (!customFilter.model || model === customFilter.model) {
							customFilter.modelResults.push(model);
						}
						if (!customFilter.engine || engine === customFilter.engine) {
							customFilter.engineResults.push(engine);
						}
					}
				}
			}
		}
	}

	uniqResults(customFilter);
	console.log(customFilter);
}

// Check if a given make, model, and year is valid given the user's current selections
function checkValid(make, model, year, engine, customFilter) {
	return (
		(!customFilter.make || make === customFilter.make) &&
		(!customFilter.model || model === customFilter.model) &&
		(!customFilter.year || year === customFilter.year) &&
		(!customFilter.engine || engine === customFilter.engine)
	);
}

function uniqResults(customFilter) {
	const uniqYears = [...new Set(customFilter.yearResults.sort())];
	const uniqMakes = [...new Set(customFilter.makeResults.sort())];
	const uniqModels = [...new Set(customFilter.modelResults.sort())];
	const uniqEngines = [...new Set(customFilter.engineResults.sort())];

	customFilter.yearResults = [...uniqYears];
	customFilter.makeResults = [...uniqMakes];
	customFilter.modelResults = [...uniqModels];
	customFilter.engineResults = [...uniqEngines];
}

// Render Product Filter
function renderProductFilter(customFilter, currentTarget) {
	console.log('customFilter', customFilter);
	console.log('currentTarget', currentTarget);

	const yearCheckboxes = document.querySelectorAll('.year-checkbox');
	const makeCheckboxes = document.querySelectorAll('.make-checkbox');
	const modelCheckboxes = document.querySelectorAll('.model-checkbox');
	const engineCheckboxes = document.querySelectorAll('.engine-checkbox');

	[
		...yearCheckboxes,
		...makeCheckboxes,
		...modelCheckboxes,
		...engineCheckboxes,
	].forEach((checkbox) => {
		checkbox.style.display = 'block';
	});

	yearCheckboxes.forEach((checkbox) => {
		if (!customFilter.yearResults.includes(checkbox.dataset.year)) {
			checkbox.style.display = 'none';
		}
	});

	makeCheckboxes.forEach((checkbox) => {
		if (!customFilter.makeResults.includes(checkbox.dataset.make)) {
			checkbox.style.display = 'none';
		}
	});

	modelCheckboxes.forEach((checkbox) => {
		if (!customFilter.modelResults.includes(checkbox.dataset.model)) {
			checkbox.style.display = 'none';
		}
	});

	engineCheckboxes.forEach((checkbox) => {
		if (!customFilter.engineResults.includes(checkbox.dataset.engine)) {
			checkbox.style.display = 'none';
		}
	});
}

// Mobile Filter TEST

// Open and close mobile filter
const mobileFilterBtn = document.querySelector(
	'.mobile-filter .uil-arrow-circle-up'
);
const mobileFilter = document.querySelector('.mobile-filter');
const mobileFilterResetBtn = document.querySelector('.reset-mobile-filter');

mobileFilterBtn?.addEventListener('click', (e) => {
	mobileFilter.classList.toggle('open');
	mobileFilterBtn.classList.toggle('open');
	mobileFilterResetBtn.classList.toggle('open');
});

// Tab click mobile filter
const mobileFilterTabs = document.querySelectorAll('.mobile-filter-tab .tab');
const mobileFilterTabContents = form?.querySelectorAll('.facets-wrap');

mobileFilterTabs.forEach((tab) => {
	tab.addEventListener('click', (e) => {
		console.log('tab', tab);
		const tabName = tab.classList[0];
		resetTabStyle();
		tab.classList.add('active');

		renderTabContent(tabName);
	});
});

function resetTabStyle() {
	mobileFilterTabs.forEach((tab) => {
		tab.classList.remove('active');
	});
}

function renderTabContent(tabName) {
	mobileFilterTabContents.forEach((tabContent) => {
		const tabContentName = tabContent.classList[0];
		if (tabContentName === tabName) {
			tabContent.classList.add('active');
		} else {
			tabContent.classList.remove('active');
		}
	});
}

// Reset Mobile Filter
mobileFilterResetBtn?.addEventListener('click', (e) => {
	e.preventDefault();
	const checkboxes = document.querySelectorAll(
		`.facets-wrap input[type="checkbox"]`
	);

	checkboxes.forEach((checkbox) => {
		checkbox.checked = false;
		checkbox.closest(`.${checkbox.name}-checkbox`).style.display = 'block';
		nameSet.clear();
	});

	// Push url to history
	window.history.pushState(null, null, collectionUrl);

	renderProductGrid(collectionUrl, '');

	// // Reset mobile filter tab style
	// resetMobileTabCheckedStyle();
});

// // Reset Mobile tab style
// function resetMobileTabCheckedStyle() {
// 	mobileFilterTabs.forEach((tab) => {
// 		tab.style.color = 'currentColor';
// 	});
// }

// Mobile Filter Option handler

// mobileFilterBtn.addEventListener('touchmove', (e) => {
// 	// e.preventDefault();
// 	// const x = e.touches[0].clientX - mobileFilter.startX;
// 	console.log('start Y', mobileFilter.startY);
// 	const y = e.touches[0].clientY - mobileFilter.startY;

// 	console.log(y);
// 	if (y <= 0 && y >= -350) {
// 		mobileFilter.style.transform = `translateY(${350 + y}px)`;
// 		const percentage = 100 - ((350 + y) / 350) * 100;
// 		console.log(percentage);
// 		const labels = document.querySelectorAll(
// 			'.mobile-filter [class$="-checkbox"] label'
// 		);
// 	}
// });

// mobileFilterBtn.addEventListener('touchend', (e) => {
// 	// Handle touch end event
// 	console.log('Touch ended');
// 	console.log(e);
// 	document.body.style.overflow = '';
// });

function handleModalInput(modal, input, value, displayMsg) {
	console.log(displayMsg);

	if (!value) {
		displayMsg.innerHTML = `
		<span>Please provide the VIN number so we can process your order.<br>
        If you don't have it right now, you can still add the item to cart. We will contact you later.</span>
		`;
		changeModalInputStyle('', input);
		return;
	} else {
		const trimmedValueLength = value.replace(/[^a-zA-Z0-9]/g, '').length;
		if (trimmedValueLength === 17) {
			vinDecode(value)
				.then((data) => {
					const { year, make, model, engineSize, hasError, errorMsg } = data;

					if (hasError) {
						displayMsg.innerHTML = `<span class="not-valid">Invalid VIN<br>Please verify the number and try again.</span>`;
						changeModalInputStyle('not-valid', input);
					} else {
						displayMsg.innerHTML = `
						<div>${year}</div>
						<div>${make}</div>
						<div>${model}</div>
						<div>${engineSize}</div>
						`;
						changeModalInputStyle('valid', input);
					}
				})
				.catch((err) => console.log(err));
		} else if (trimmedValueLength < 17 && trimmedValueLength > 13) {
			displayMsg.innerHTML = `<span class="info">You've entered ${trimmedValueLength} characters.<br>VIN consists of 17 alphanumeric characters.</span>`;
			changeModalInputStyle('info', input);
			vinDecode(value).then((data) => {
				console.log('api warm up');
			});
		} else {
			displayMsg.innerHTML = `<span class="info">You've entered ${trimmedValueLength} characters.<br>VIN consists of 17 alphanumeric characters.</span>`;
			changeModalInputStyle('info', input);
			return;
		}
	}
}

function changeModalInputStyle(state, input) {
	console.log('input from function', input);
	const icon = input.closest('.quick-form-input-wrapper').querySelector('i');
	console.log('icon from function', icon);

	if (state === 'valid') {
		input.style.outline = '2px solid #2ecc71';
		icon.className = '';
		icon.classList.add('uil', 'uil-check-circle', `${state}`);
	} else if (state === 'not-valid') {
		input.style.outline = '2px solid #e74c3c';
		icon.className = '';
		icon.classList.add('uil', 'uil-info-circle', `${state}`);
	} else if (state === 'info') {
		input.style.outline = '2px solid #184d7e';
		icon.className = '';
		icon.classList.add('uil', 'uil-info-circle', `${state}`);
	} else {
		//default
		input.style.outline = '1px solid currentColor';
		icon.className = '';
		icon.classList.add('uil', 'uil-keyboard-alt');
	}
}
